window.httpRequest = function(url, postData, options) {
    return new Promise(function (resolve, reject) {
        var defaultOptions = {
            type: "post",
            datatype: "json",
            cache: false,
            async: true,
            showLoader: true,
            contentType: 'application/x-www-form-urlencoded',
            processData: true
        };

        if (typeof postData == 'undefined' || postData == null) {
            postData = {};
        }
        if (typeof options !== 'undefined') {
            defaultOptions = Object.assign({}, defaultOptions, options);
        }

        $.ajax({
            type: defaultOptions.type,
            url: url,
            dataType: 'json',
            cache: false,
            async: true,
            contentType: defaultOptions.contentType, 
            processData: defaultOptions.processData, 
            data: postData,
            xhr: function () {
                var xhr = new window.XMLHttpRequest();
                xhr.upload.addEventListener("progress", function (evt) {
                    if (evt.lengthComputable) {
                        var percentComplete = (evt.loaded / evt.total) * 100;
                        var event = new CustomEvent('onUploadFileProgress', { bubbles: true, detail: {
                            'action':url,
                            'progress': percentComplete,
                            'total' : evt.total,
                            'loaded': evt.loaded
                        } });
                        document.dispatchEvent(event);
                    }
                }, false);
                return xhr;
            },
            beforeSend: function (formData, jqForm, options) {
                if (typeof authToken !== 'undefined') {
                    formData.setRequestHeader("Authorization", authToken);
                }
                if (typeof sessionType !== 'undefined') {
                    formData.setRequestHeader('Session',sessionType);
                }
                if (defaultOptions.showLoader) {
                    $('body').addClass('onLoading');
                }
            },
            success: function (dati) {
                if (typeof environment !== 'undefined' && environment != 'production') console.log(dati);
                var jsonDati = dati;
                resolve(jsonDati);

            },
            error: function (jqxhr, textstatus, errorthrown) {
                reject(jqxhr);
            },
            complete: function () {
                if (defaultOptions.showLoader) {
                    $('body').removeClass('onLoading');
                }
                window.onkeydown = window.onfocus = null;
            }
        });
    });
}

window.saccessAnimation= function() {
    return  `<div class="success-send-request" style="    position: absolute;width: 100%;height: 100%;">
        <div class="" style="top: 50%;position: relative;transform: translateY(-50%);">
            <div class="content text-center" style="display:block;position:relative;">
                <div class="success-checkmark">
                    <div class="check-icon">
                        <span class="icon-line line-tip"></span>
                        <span class="icon-line line-long"></span>
                        <div class="icon-circle"></div>
                        <div class="icon-fix"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>`;
}

window.showToast =function(param) {
    if (!param.id) {
        param.id= Math.floor(Math.random() * 101);
    }

    if ($('#containerToast').length == 0) {
        $('body').append('<div id="containerToast" style="position: fixed; bottom: 10px; right: 10px;z-index:100"></div>');
    }

    var template= '<div id="'+param.id+'" role="alert" aria-live="assertive" aria-atomic="true" class="toast" data-role="toastAlert" data-autohide="false">'
                    +'<div class="toast-header">';
    if (param.header) {
        template+=param.header;
    }
    template+='<button type="button" class="ml-auto mb-1 close" data-dismiss="toast" aria-label="Close">'
                +'<span aria-hidden="true">&times;</span>'
                +'</button>'
                +'</div>'
                +'<div class="toast-body">';
    if (param.body) {
        template+=param.body;
    }
    template+='</div>'
    +'</div>';

    $('#containerToast').append(template);
    $('#'+param.id).toast('show');
    if (param.dismiss > 0) {
        setTimeout(function () {
            hideToast($('#'+param.id));
        },param.dismiss);
    }
    return $('#'+param.id);
}
window.hideToast = function(target) {
    if (target == null) {
        target = '.toast';
    }
    $(target).toast('hide')
    setTimeout( function() {
        $(target).remove();
        if ($('[data-role="toastAlert"]').length == 0) {
            $('#containerToast').remove();
        }
    },1000);
}

window.showError = function(error) {
    Swal.fire({
        title: '',
        html: error,
        icon: 'error',
        showCancelButton: false,
        customClass: {
            confirmButton: 'btn btn-danger',
        },
        buttonsStyling: false,
        confirmButtonText: "Ok",
    });
}

window.showWarning = function(error) {
    Swal.fire({
        title: '',
        html: error,
        icon: "warning",
        showCancelButton: false,
        customClass: {
            confirmButton: 'btn btn-warning',
        },
        buttonsStyling: false,
        confirmButtonText: "Ok",
    });
}


window.question= function(text, respons, option) {
    if (typeof option === 'undefined' || option == null) {
        option = {};
    }
    if (option.title === 'undefined' || option.title == null) {
        option.title = '';
    }
    if (text === 'undefined' || text == null) {
        option.html = 'Confermi di voler eliminare l\'elemento selezionato?';
    } else {
        option.html = text;
    }
    if (option.icon === 'undefined' || option.icon == null) {
        option.icon = 'warning';
    }
    if (option.showCancelButton === 'undefined' || option.showCancelButton == null) {
        option.showCancelButton = true;
    }
    if (option.confirmButtonText === 'undefined' || option.confirmButtonText == null) {
        option.confirmButtonText = 'SI';
    }
    if (option.cancelButtonText === 'undefined' || option.cancelButtonText == null) {
        option.cancelButtonText = 'NO';
    }
    if (option.customClass === 'undefined' || option.customClass == null) {
        option.customClass = {
            confirmButton: 'btn btn-warning m-1 order-2',
            cancelButton: 'btn btn-light m-2 order-1'
        };
    } else {
        if (option.customClass.confirmButton === 'undefined' || option.customClass.confirmButton == null) {
            option.customClass.confirmButton = 'btn btn-warning m-2 order-2';
        }
        if (option.customClass.cancelButton === 'undefined' || option.customClass.cancelButton == null) {
            option.customClass.cancelButton = 'btn btn-light m-2 order-1';
        }
    }
    option.buttonsStyling = false;

    Swal.fire(option).then((confirm) => {
        if (confirm.isConfirmed) {
            respons(confirm)
        }
    });
}

window.hexToRgb = function(c) {
    if (/^#([a-fA-F0-9]{3}){1,2}$/.test(c)) {
        if (c.length == 4) {
            c = '#' + [c[1], c[1], c[2], c[2], c[3], c[3]].join('');
        }
        c = '0x' + c.substring(1);
        return [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',');
    }
    return '';
}

window.formatBytes = function(bytes, decimals = 2) {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

window.wt_event = function(event,target,id_target) {
  postData = {
      event:event,
      target:target,
      path:window.location.href,
      id_target:id_target,
      width:window.innerWidth,
      referrer:document.referrer,
  };
  httpRequest(base_url+'api/wt_event',postData);
}
window.checkQtaProdotto = function(qta) {
  if (parseInt(qta) >= parseInt(prodotto.realQta)) {
      $('.inc-btn').addClass('disabled');
  } else {
      $('.inc-btn').removeClass('disabled');
  }

  if (parseInt(qta) == 1) {
      $('.dec-btn').addClass('disabled');
  } else {
      $('.dec-btn').removeClass('disabled');
  }


  var event = new CustomEvent('onChangeQtaProdotto',{bubbles: true,detail:{qta:parseInt(qta)}});
  $(document)[0].dispatchEvent(event);
}
window.slideMenuFilter = function() {
  if ($('#col-filter').hasClass("show")) {
      $('#col-filter').removeClass("show");
      $('#col-filter').addClass("slide-out");
      $('body').removeClass('no-scroll');
  } else {
      $('#col-filter').addClass("show");
      $('#col-filter').removeClass("slide-out");
      $('body').addClass('no-scroll');
  }
}
window.setCookie = function(cname, cvalue, exdays, path) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires="+d.toGMTString();
  document.cookie = cname + "=" + cvalue + "; " + expires + "; path=" + path;
}

window.isOnScreen= function(el) {
  var rect = el.getBoundingClientRect();
  var elemTop = rect.top;
  var elemBottom = rect.bottom;

  // Only completely visible elements return true:
  var isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight);
  // Partially visible elements return true:
  //isVisible = elemTop < window.innerHeight && elemBottom >= 0;
  return isVisible;
}

window.scrollTo = function (elm,y) {
  /* questo può andare in catch nel caso in cui non esiste l'elemento */
  try {
      var scrollTop = 0;
        if (y && y > 0) {
        scrollTop = y;
      } else  if (typeof $(elm).offset().top !== 'undefined') {
          scrollTop = $(elm).offset().top - 20;
          
      }
      if (scrollTop) {
            $('html,body').animate({
                scrollTop: scrollTop
            }, 'slow');
      }
  } catch (e) {
      console.error(e);
  }
}
window.startLoading = function() {
  $('#overlayer').fadeIn(10);
}
window.stopLoading = function() {
  $('#overlayer').hide();
}
window.bs_input_file =  function() {
  $(".input-file").before(
      function() {
          if ( ! $(this).prev().hasClass('input-ghost') ) {
              var element = $("<input type='file' class='input-ghost' style='visibility:hidden; height:0'>");
              element.attr("name",$(this).attr("name"));
              element.change(function(){
                  element.next(element).find('input').val((element.val()).split('\\').pop());
              });
              $(this).find("button.btn-choose").click(function(){
                  element.click();
              });
              $(this).find("button.btn-reset").click(function(){
                  element.val(null);
                  $(this).parents(".input-file").find('input').val('');
              });
              $(this).find('input').css("cursor","pointer");
              $(this).find('input').mousedown(function() {
                  $(this).parents('.input-file').prev().click();
                  return false;
              });
              return element;
          }
      }
  );
}

window.reloadCittaFromProvincia = function(obj,target) {
  httpRequest(base_url+'citta',{id_provincia:parseInt(obj.val().trim())}).then( function (res) {
      var options = '';
      if (res.result) {
          var options = '';
          options = '<option value>Seleziona una città</option>';
          $.each(res.citta, function (k,v) {
              options += '<option value="' + v.id + '">' + v.nome + '</option>';
          });
      }console.log($(target));console.log(target);
      $(target).html(options);
  });
}
window.reload_citta = function(drop_prov,id_drop_citta)
{
  if (drop_prov.value > 0){
      $.ajax(
      {
          url: base_url+"ajax/create_xml_citta",
          datatype: "xml",
          type: "post",
          beforeSend: function(formData, jqForm, options) {
              $('#overlayer').fadeIn(100);
          },
          data: {
                  ID_provincia: drop_prov.value,
                  sidx:'nome'
          },
          success: function(data)
          {
              var options = '';
              options = '<option value>Seleziona una città</option>';
              $("row", data).map(function()
              {
                  var row_data = ($("cell", this));
                  options += '<option value="' + row_data[0].childNodes[0].nodeValue + '">' + row_data[1].childNodes[0].nodeValue + '</option>';
              })
              $("#"+id_drop_citta).html(options);
              if(drop_prov.id=='provincia_residenza' && $('#provincia_fatturazione').attr('disabled')=='disabled')
              {
                  $('#citta_fatturazione').html(options);
              }
          },
          complete: function() {
              setTimeout(function(){$('#overlayer').hide();},100);
          }
      });
  }else{
      var options = '<option value>Seleziona una provincia o stato estero...</option>';
      $("#"+id_drop_citta).html(options);
      if(drop_prov.id=='provincia_residenza' && $('#provincia_fatturazione').attr('disabled')=='disabled')
      {
          $('#citta_fatturazione').html(options);
      }
  }
}



window.startLoader = function () {
  stopLoader();
  $('body').append(
      '<div class="progress" id="global-progress-bar">'
          +'<div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"'
            +'aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width:100%">'
              +'Attendi...'
          +'</div>'
          +'</div>'
  );
}
window.stopLoader = function() {
  $('#global-progress-bar').remove();
}